import { MprcIconButtonDropdown } from "components";
import { MprcFilterLine } from "components/filter";
import { MprcCardFilterBox } from "components/filter/MprcCardFilterBox";
import { IconSort } from "components/icons";
import { MprcSearchTextField, MprcSearchTextFieldHandle } from "components/MprcSearchTextField";
import { ManagerEfficacyUserOrderBy } from "generated/CoreApi_v1";
import React, { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { UsersManagerEfficacyOptions } from "views/assessment/managerEfficacy/ListUsersManagerEfficacy";

interface IProps {
    filterOptions: UsersManagerEfficacyOptions;
    onFilterChange: (filter: UsersManagerEfficacyOptions) => void;
}

const FilterRender: React.ForwardRefRenderFunction<MprcSearchTextFieldHandle, IProps> = (props, forwardRef) => {

    const { filterOptions, onFilterChange } = props;

    const { t } = useTranslation("assessment");

    ///
    const getOrderItems = useMemo(() => {
        const items = [
            { text: t("ManagerEfficacy.List.OrderBy.Older"), value: ManagerEfficacyUserOrderBy.Older, key: 0 },
            { text: t("ManagerEfficacy.List.OrderBy.Recently"), value: ManagerEfficacyUserOrderBy.Recently, key: 1 },
            { text: t("ManagerEfficacy.List.OrderBy.Name"), value: ManagerEfficacyUserOrderBy.Name, key: 2 },
        ];
        return items;
    }, []);

    ////////////////////////////////////////////////////////////////////////////////
    /// RENDER
    ////////////////////////////////////////////////////////////////////////////////

    return (
        <MprcCardFilterBox>
            <MprcFilterLine>
                <MprcSearchTextField
                    confirmMode="debounce"
                    ref={forwardRef}
                    onConfirm={(value) => onFilterChange({ ...filterOptions, searchText: value })}
                    placeholder={t("Search.TextPlaceholder", { ns: "shared" })}
                />
                <div>
                    <MprcIconButtonDropdown
                        title={t("Filter.OrderBy", { ns: "shared" })}
                        icon={<IconSort />}
                        onChange={(orderBy) => onFilterChange({ ...filterOptions, orderBy })}
                        items={getOrderItems}
                        selected={filterOptions.orderBy}
                        menuItemCheck
                        color="primary"
                    />
                </div>
            </MprcFilterLine>
        </MprcCardFilterBox >
    );
};

export const Filter = React.forwardRef(FilterRender);